import React from 'react';

const ComingSoon = () => {
  return (
    <div className="coming-soon-wrapper">
      <div className="coming-soon-content">
        <h1>Coming Soon</h1>
        <p>We're working hard to launch something amazing.</p>
      </div>
    </div>
  );
};

export default ComingSoon;
